// sceneChladniPatterns.js

import ChladniParticleManager from '../../classes/chladniParticleManager';
import Position from '../../classes/position';
import Scene from '../../classes/scene';
import Utils from '../../classes/utils';


export default class SceneChladniPatterns extends Scene {
    constructor(args) {
        super(args);
        this.pointer = true;
   }

    init(data) {
        super.init(data);
        let f = this.system.factory;
        let pal = this.system.palette;
        //let scr = this.system.screen;

		this.particles = new ChladniParticleManager({
			scene: this
		});
        // For demonstration purposes, let's just add a simple text to indicate this is the Chladni Patterns scene
        f.text({
            x: '50%', y: '50%', scale: 2,
            text: 'Chladni Patterns Scene',
            color: pal.blue
        });
		f.button({
			x:'50%', y:'75% 40', scale: 1.25,
			//layer:'overlay',
			text:'sand',
			align:'center',
			color: pal.white,
			onClick: () => {
				this.createSand();
			}
		});


		f.button({
			x:'100% -50', y:50, scale: 1,
			text:'back',
			align:'right',
			color: pal.red,
			onClick: () => {
				this.system.sceneManager.changeScene('sceneParticleDemo');
				this.system.audio.playSample('gui_tiny');
				this.system.audio.stopMusic();
			}
		});
    }

    createSand() {
		let scr = this.system.screen;
		let pal = this.system.palette;
		let f = this.system.factory;

		this.particles.createSand({
			origin:new Position({
				x:scr.width*0.5,
				y:scr.height*0.5,
				xv:Utils.randomFloat(-1,1),
				yv:Utils.randomFloat(-1,1)
			}),
			color:[pal.green, pal.yellow, pal.magenta],
			power:2,
			amount:100,
			spread:50,
			expire:4000,
			expireSlop:200,
			slop:5,
			minSlop:0,
			velocityInherit:2
		});
	}
    // ... other methods like update, onPointerMove, etc.
}